import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Header } from '@els/els-react--header';
import Auth from '@Services/Auth';
import Catalyst from '@Services/Catalyst';
import OutdatedBrowserModal from '@Components/OutdatedBrowserModal';
import { Link } from 'react-router-dom';
import { paths } from '@AppRoutes/constants.js';
import GeneralMenuItems from '@Containers/Header/GeneralMenuItems';
import BrandingContainer from './Branding/BrandingContainer';
import UnauthSiteNavigationContainer from './UnauthSiteNavigation/UnauthSiteNavigationContainer';
import DashboardNavigationContainer from './DashboardNavigation/DashboardNavigationContainer';

import '@els/els-react--header/dist/els-styleguide-header.scss';
import './HeaderComponent.scss';

function HeaderComponent({ type, companyLogoUrl }) {
  const isMain = type === 'main';
  const isUnauth = type === 'unauth';
  const isAnonymousUser = Auth.isAnonymousUser();
  function getTitle() {
    return <h1 className="u-els-color-elsevier-orange u-els-font-size-h3">Reaxys</h1>;
  }

  return (
    <>
      <Header
        id="header"
        className={classnames('header-main-nav', {
          'header-anonymous-main-nav': isAnonymousUser,
        })}
        wordmark={getTitle()}
        wordmarkLink={{
          id: 'main-header-wordmark',
          href: paths.LANDING,
          routerComponent: Link,
          routerHrefAttribute: 'to',
          onClick: () => Catalyst.trackContentLinkClick('header:branding:logo'),
        }}
        tabIndex="0"
        treeOnly>
        {companyLogoUrl && <BrandingContainer />}

        {isMain && (
          <div className="u-els-display-none@tablet">
            <GeneralMenuItems />
          </div>
        )}
        {isUnauth && <UnauthSiteNavigationContainer />}
        {isMain && <DashboardNavigationContainer />}
      </Header>
      <OutdatedBrowserModal />
    </>
  );
}

HeaderComponent.propTypes = {
  type: PropTypes.string.isRequired,
  companyLogoUrl: PropTypes.string,
};

export default HeaderComponent;
